<template>
  <v-dialog
    v-model="dialog"
    width="420px">
    <div
      class="dialog-container"
    >
      <div class="plan-header">
        <div class="info flex">
          <h3>Issue Policy with API</h3>

          <i
            class="el-icon-close"
            @click="handleCancel"></i>
        </div>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="item-content">
            <div class="form-item">
              <span>車牌號碼</span>
              <el-form-item
                ref="rgtn_no"
                prop="rgtn_no">
                <v-input
                  v-model="formData.rgtn_no"
                  :uppercase="true"
                  maxlength="8"
                  type="text"/>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button @click="handleCancel">Cancel</v-button>
        <v-button
          type="primary"
          @click="onContinue">Continue</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import {issueCNApi} from '@api/policy'

export default {
  name: 'openIssuePcyDialog',
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    value:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dialog: false,
      formData: {
        rgtn_no: '',
      },
      extraRules: {
        rgtn_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed:{
  },
  watch: {
    value:{
      immediate:true,
      handler(val){
        this.dialog = val
        this.init()
      }
    },
  },
  methods: {
    init(){
      let {rgtn_no} = this.form||{}
      this.formData.rgtn_no = rgtn_no
    },
    handleCancel(){
      this.$emit('input',false)
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.network().issueCNApi()
        }
        else {
          console.log(rules)
        }
      })
    },
    network() {
      return {
        issueCNApi: async () => {
          const {data} = await issueCNApi({
            order_id:  this.orderId,
            ...this.formData,
            type:1
          })
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.$emit('update')
          }
          this.$emit('input',false)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  .dialog-body{
    padding: 15px;
  }
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .item-content{
    padding-bottom: 30px;
    padding-top: 20px;
  }
  .title-span{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
    margin-top: 30px;
  }
  h3 {
    padding-bottom: 5px;
  }
  p {
    padding-bottom: 10px;
  }
  .dialog-footer {
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
    display: flex;
    justify-content: space-between;
  }
  .form-item {
    & > span {
      //font-weight: bold;
      //font-size: 16px;
    }
  }
  .flex-align{
    align-items: center;
    .margin-time{
      margin: 0 10px;
    }
  }
}
</style>
